/**
 * TRIAGE, NOT A SECOND CHECKLIST.
 *
 * This began as full rows — label, detail, responsible person and two buttons
 * each. With twelve blocking items it stood 330 pixels tall, pushed the whole
 * workflow below the fold, and reproduced most of the Readiness stage one
 * screen above it. Two places listing the same twelve things is how somebody
 * learns to read neither.
 *
 * So it answers one question: WHERE is the work. A count, and how it splits
 * across stages, each one a way in. What each item actually is lives in
 * Readiness, which is where the full list belongs and still has it.
 *
 * It stays quieter than the Next Action above it on purpose. That panel says
 * what to DO; this one says what is outstanding, and of the two the first is
 * the one somebody should read first.
 */
import page from '../../../shared/Page.module.css';
import own from './Onboarding.module.css';
import type { Onboarding, StageId } from './types';

export function NeedsAttentionPanel({
  data, onGo,
}: {
  data: Onboarding;
  onGo: (stage: StageId) => void;
}) {
  const blocking = data.attention.filter((r) => r.blocking);
  if (blocking.length === 0) return null;

  // In stage order, which is the order the work happens in — not by size,
  // which would put whichever stage happens to have most items first.
  const byStage = data.stages
    .map((stage) => ({
      stage,
      count: blocking.filter((r) => r.stage === stage.id).length,
    }))
    .filter((row) => row.count > 0);

  return (
    <section className={own.attention} aria-labeledby="attention-title">
      <div className={own.attentionHead}>
        <h2 id="attention-title" className={own.attentionTitle}>
          Needs attention — {blocking.length}
        </h2>
        <button type="button" className={page.btn} onClick={() => onGo('readiness')}>
          Review blockers
        </button>
      </div>

      <ul className={own.attentionCounts} aria-label="Blocking items by stage">
        {byStage.map(({ stage, count }) => (
          <li key={stage.id}>
            <button
              type="button"
              className={own.attentionCount}
              onClick={() => onGo(stage.id)}
            >
              <span className={own.attentionCountNumber}>{count}</span>
              {stage.title}
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
}
